import React from 'react';

// sort flags alphabetically to match flag-smith order
export const DefaultFlagsContext = {
  EnableAdvancedBranding: false,
  EnableChannelsClientDetails: false,
  EnableClientPersonalBranding: false,
  EnableClientInviteEnhancement: false,
  EnableEmailNotificationsDigest: false,
  EnableFeeFlexibilityFlow: false,
  EnableFilesApi: false,
  EnableFilesNotificationCenter: false,
  EnableImprovedForms: false,
  EnableNewPricingPlans: false,
  EnableUpdatedSignatureComponents: false,
  EnableUpdatedSignatureCreationFlow: false,
  EnableNotificationSettings: false,
  EnableClientsImport: false,
  EnableMfa: false,
};

export type FlagContextType = Record<keyof typeof DefaultFlagsContext, boolean>;

export const FlagsContext = React.createContext(DefaultFlagsContext);
